import React, {useState} from "react";
import clinicService from "../../../../../services/clinic.service";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";

function AddCustomization({customValue, updateCustomization}) {
    const [showButton, setShowButton] = useState(false);
    const [cVal, updateCVal] = useState(customValue);
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset
    } = useForm();
    const {clinicId} = useParams();
    const handleToogle = () => {
        setShowButton(!showButton);
    };
    const onSubmit = (data) => {
        console.log(data);
        const newData = [data];
        clinicService
            .updateCustomization(clinicId, newData)
            .then((res) => {
                //console.log(res.data)
                updateCustomization(res.data);
                toast.success("Added", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                reset();
            })
            .catch((err) => {
                console.log(err);
            });
    };
    return (
        <>
            {showButton ? (
                <>
                    <hr/>
                    <div className="card-body shadow-none">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3">
                                Add a new customization
                            </div>
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">
                                    {" "}
                                    Key
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Key"
                                    {...register("optionKey", {required: true})}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="" className="form-label">
                                    Value
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Value"
                                    {...register("optionValue", {required: true})}
                                />
                            </div>
                            <div className="d-flex justify-content-between">
                                <button type="submit" className="btn btn-success btn-sm">
                                    <i className="bi bi-floppy"></i> Save
                                </button>

                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleToogle()}
                                >
                                    <i className="bi bi-x"></i> Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </>
            ) : (
                <button
                    className="btn btn-outline-primary btn-sm mt-3 ms-2"
                    onClick={() => handleToogle()}
                >
                    <i className="bi bi-plus"></i> Add New
                </button>
            )}
        </>
    );
}

export default AddCustomization;
